
import img0 from './Images/Okta_OIDC1.png';
import img1 from './Images/Okta_OIDC2.png';
import img2 from './Images/Okta_OIDC3.png';
import img3 from './Images/Okta_OIDC4.png';
import img4 from './Images/Okta_OIDC_Policy.png';
import img5 from './Images/Okta_OIDC_Rule.png';
import img6 from './Images/Okta_OIDC5.png';
  
const content = `# Okta Integration Using OIDC
OnData supports the integration with Identity and Access Management (IAM) systems for user authentication and authorization, based on the industry standard 
protocols, including SAML 2.0 and OpenID Connect (OIDC) protocols. The purpose of this document is to detail the process of configuring OnData and Okta using 
the OpenID Connect protocol, so that the users can login to OnData with their Okta accounts.

### 1. Prerequisite
a. An Okta user account with at least one of the following roles: Super Administrator, or Application Administrator  
b. An OnData account with the System Administrator role  

### 2. Okta Configuration
a. Login to the Okta Admin Console, go to “Applications” -> “Applications”  
b. Click “Create App Integration”  
c. Select “OIDC – OpenID Connect” as the Sign-in method  
d. Choose “Web Application” as the type of app and click “Next”  
e. Use “OnData Portal” as the “App integration name”  
f. Find the "Login Redirect URL" and "Logout Redirect URL" from the OnData Portal. Below are the steps:  
  * Login to the OnData Portal as a System Administrator, select the "Settings" icon from the top right corner, and select "Organization" from the dropdown menu  
  * Select the "SSO Configuration" tab  
  * Toggle the switch to "Enable Single Sign-ON (SSO)"  
  * Under the "Protocol" choice, select the "OpenID Connect" option
  * Copy the "Login Redirect URL" and "Logout Redirect URL"

g. Paste the "Login Redirect URL" from the OnData Portal to complete the “Sign-in redirect URIs” field, which should be: https://api.ondatahub.com/users/api/sso/oidc/consumer. 
Paste the "Logout Redirect URL" from the OnData Portal to complete the Enter the “Sign-out redirect URIs” field, which should be: https://us.ondatahub.com  
h. Select the "Skip group assignment for now" option under "Assignments", leave all other fields with default values, and click “Save” to create this application  

![Create New Application](${ img0 })

i. On the “General” tab, copy the following values  
- Copy the “Client ID”, which is needed to configure the “Client Id” field at the OnData side
- Copy the “Client Secret”, which is needed to configure the “Client Secret” field at the OnData side

j. Go to “Security” -> “API” and click “default” (or whatever the authorization server is used) under the “Authorization Servers” tab  
- Copy the URL for the "Issuer" under the "Settings" tab, which is needed to configure the "Well Known Configuration URL" field at the OnData side
- Click the "Metadata URI" and copy the URL for "end_session_endpoint" from the metadata, which is needed to configure the “On Logout, Sign Out IdP at URL” field at the OnData side

k. Go to “Directory” -> “Profile Editor” and select “Apps” under the “Users” tab  
l. Click the “OnData Portal User” profile to show the “Profile Editor”  
m. Click “Add Attribute” to add an attribute with the following options  
- Data type: string array
- Display name: OnData App Roles
- Variable name: Roles
- Enum: check the “Define enumerated list of values” option, enter “System Administrator” as the “Display name”, and “SystemAdministrator” as the “Value”
- Attribute required: check the “Yes” option
- Attribute type: select the “Group” option
- Group Priority: select the "Combine values across groups" option
- Leave all other fields as default and click “Save”

 ![App Role Attribute](${ img1 })

n. Go to “Directory” -> “Groups” and select “Add group” to add new group  
o. Use the group name of “OnData Admins” (or whatever names preferred) and click “Save”  
p. Click the newly added "OnData Admins" group, and under the “People” tab, assign one or more users to this group who will be the OnData system administrators  
q. Under the “Application” tab, click “Assign applications”  
r. Find the “OnData Portal” application and click “Assign”  
s. Select “System Administrator” for the “OnData App Roles”  
t. Click “Save and Go Back” to save the assignment  
u. Click “Done” to complete the assignment  

 ![Assign Application](${ img2 })

v. Go to “Security” -> “API” and click “default” (or whatever the authorization server is used) under the “Authorization Servers” tab  
w. Under the “Claims” tab, click “Add Claim” to add a new claim with the following options  
- Name: Roles
- Include in token type: ID Token
- Value type: Expression
- Value: appuser.Roles
- Leave all other fields as default and click “Create”

 ![Add App Role Claim](${ img3 })
  
x. Under the "Access Policies" tab of the same page above, click "Add Policy" to add a new access policy with the following options  
- Name: provide a name
- Description: provide a Description
- Assign to: select "All clients"
- Click on "Create Policy" to create this new policy

 ![Add OIDC Access Policy](${ img4 })
  
y. Once the access policy is created, click on "Add rule" to add a new rule with the following options  
- Rule Name: provide a name
- Leave all other fields as default and click “Create rule” to create this rule

 ![Add OIDC Access Rule](${ img5 })
  
### 3. OnData Configuration
a. Login to OnData as a System Administrator, select the Settings icon from the top right corner, and select Organization from the dropdown menu  
b. Select the SSO Configuration tab  
c. Toggle the switch to “Enable Single Sign-ON (SSO)”  
d. Under the Protocol choice, select the “OpenID Connect” option  
e. Fill out the “Well Known Configuration URL” field with the Okta Issuer URL you copied in Step 2.j above  
f. Fill out the “Client Id” field with the value of the “Client ID” field from the Okta application “General” tab  
g. Fill out the “Client Secret” field with the “Client Secret” copied from the Okta application “General” tab  
h. Fill out the “On Logout, Sign Out IdP at URL” field with the value of the "end_session_endpoint" you copied in Step 2.j above  
i. Click on the “Update SSO Configuration” button to update the SSO settings  
j. Log out of OnData and login again with a user’s organization email address who has been granted access to the OnData Portal application  
k. You should be redirected to Okta for login. After a successful login, you will be redirected back to the OnData Portal  

 ![OnData SSO Configuration](${ img6 })

`
  
export default content;
